module.exports = __webpack_public_path__ + "img/coach.6d4ab19d.png";